<template>
  <div class="login-box">
    <div class="login-txt">
      <el-tabs v-if="isCn == 1" v-model="activeName" class="tab">
        <el-tab-pane label="密码登录" name="password"></el-tab-pane>
        <el-tab-pane label="验证码登录" name="phone"></el-tab-pane>
      </el-tabs>
      <span v-else>{{ langList && langList.login ? langList.login : '登录' }}</span>
      <div class="language-list" v-if="isCn != 1">
        <el-popover placement="bottom" popper-class="languagePopper" width="200" trigger="hover">
          <i slot="reference" style="cursor: pointer" v-if="curLang">
            <img class="icon-language" :src="curLang.icon" />
            <span class="lng-txt">{{ curLang ? curLang.name : '' }}</span>
          </i>
          <ul>
            <li
              class="lang-item"
              v-for="(item, index) in languageList"
              :key="index"
              :data-id="item.id"
              @click="setLanuage(item)"
            >
              <img class="icon-language" :src="item.icon" />
              <span>{{ item.name }}</span>
            </li>
          </ul>
        </el-popover>
      </div>
    </div>
    <el-form
      v-if="activeName == 'password'"
      key="form1"
      ref="ruleForm"
      label-position="left"
      label-width="0"
      :model="form"
      :rules="rules"
    >
      <el-form-item size="large" prop="user">
        <el-input
          autocomplete="on"
          v-model="form.user"
          name="username"
          type="text"
          :placeholder="langList && langList.account ? langList.account : '账号'"
        ></el-input>
      </el-form-item>
      <el-form-item size="large" prop="pwd">
        <el-input
          autocomplete="on"
          v-model="form.pwd"
          name="password"
          :type="passWordTxtShow ? 'text' : 'password'"
          :placeholder="langList && langList.password ? langList.password : '密码'"
          @keyup.enter.native="login"
        >
          <img
            slot="suffix"
            :src="passWordTxtShowSrc"
            @click="passWordTxtShow = !passWordTxtShow"
            class="password-close-icon"
          />
        </el-input>
      </el-form-item>
      <el-form-item size="large" prop="verificationCode">
        <el-row>
          <el-col :span="10">
            <el-input
              v-model="form.verificationCode"
              :placeholder="langList && langList.captcha ? langList.captcha : '验证码'"
              @keyup.enter.native="login"
            ></el-input>
          </el-col>
          <el-col :span="14" class="verify-box">
            <span
              style="width: 100%"
              v-html="verifyImg"
              ref="codeImg"
              id="verify-img-box"
              @click="changeVerifyCode"
            ></span>
            <span class="change-txt" @click="changeVerifyCode">
              {{ langList && langList.changesCaptcha ? langList.changesCaptcha : '换一张' }}
            </span>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <div style="display: flex">
          <el-button class="login-btn" @click="login">
            {{ langList && langList.login ? langList.login : '登录' }}
          </el-button>
          <a v-if="isCn == 1" style="flex: 1" :href="'./forgetPassword' + '?account=' + form.user">
            <el-button
class="forget—btn"
style="height: 100%; margin-left: 10px"
              >忘记密码？
            </el-button>
          </a>
        </div>
      </el-form-item>
      <p class="rechange-pwd" v-if="changePwdUrl && isCn == 1">
        <span v-if="google_url">获得更好体验，<a :href="google_url">前往下载google浏览器</a></span>
      </p>
      <div class="tip-link" v-else-if="isCn != 1 && isShowExtraLink">
        <div>
          <div>{{ langList.loginPageTip }}</div>
          <div>
            <a
              href="https://ccc-open.qbookingsolutions.com/page/article?n=common.clause.qeeq.ercp.useragreem"
              target="_blank"
            >
              {{ langList.TermsOfUse }}</a
            >
            {{ langList.and }}
            <a
              href="https://ccc-open.qbookingsolutions.com/page/article?n=common.clause.qeeq.ercp.privacy"
              target="_blank"
              >{{ langList.PrivacyPolicy }}</a
            >
          </div>
        </div>
      </div>
    </el-form>
    <Loginbyphone v-else-if="activeName == 'phone'" key="form2"></Loginbyphone>
  </div>
</template>
<script>
import { encryptInfo, cookie } from '@/common/util-front.js'
import {
  checkLogin,
  getPubCode,
  changeVerifyCode,
  getLangList,
  setLanguage,
  setToken
} from '@/model/login.js'
import Loginbyphone from '@/common-comp/LoginByPhone.vue'
export default {
  components: { Loginbyphone },
  data() {
    const isCn = window.RENDER_DATA && window.RENDER_DATA.isCn
    return {
      activeName: 'password', // phone
      isCn: isCn,
      langList: {},
      passWordTxtShow: false,
      verifyImg: '',
      publicCry: '',
      form: {
        user: '',
        pwd: '',
        verificationCode: ''
      },
      google_url: '',
      changePwdUrl: '',
      isShowExtraLink: true
    }
  },
  computed: {
    passWordTxtShowSrc() {
      return this.passWordTxtShow
        ? '//static.zuzuche.com/assets/ercp/app/apk/close-eye.png'
        : '//static.zuzuche.com/assets/ercp/app/apk/open-eye.png'
    },
    languageList() {
      const self = this
      return [
        {
          id: 1,
          name: self.langList && self.langList.english ? self.langList.english : 'english',
          attribute: 'en',
          icon: require('../assets/img/langImg/en.png')
        },
        {
          id: 2,
          name: self.langList && self.langList.chinese ? self.langList.chinese : 'chinese',
          attribute: 'zh_CN',
          icon: require('../assets/img/langImg/cn.png')
        }
      ]
    },
    languageId() {
      const langId = cookie().get('language_id')
      return langId || ''
    },
    curLang() {
      let cur = this.languageList && this.languageList.length ? this.languageList[0] : null
      this.languageList.some((item) => {
        if (item.id.toString() === this.languageId) {
          cur = item
        }
      })
      return cur
    },
    rules() {
      return {
        user: [
          {
            required: true,
            message:
              this.langList && this.langList.plusername ? this.langList.plusername : '请输入账号',
            trigger: 'blur'
          },
          {
            required: true,
            message:
              this.langList && this.langList.plusername ? this.langList.plusername : '请输入账号',
            trigger: 'change'
          }
        ],
        pwd: [
          {
            required: true,
            message: this.langList && this.langList.plpwd ? this.langList.plpwd : '请输入密码',
            trigger: 'blur'
          },
          {
            required: true,
            message: this.langList && this.langList.plpwd ? this.langList.plpwd : '请输入密码',
            trigger: 'change'
          }
        ],
        verificationCode: [
          {
            required: true,
            message: this.langList && this.langList.plcap ? this.langList.plcap : '请输入验证码',
            trigger: 'blur'
          },
          {
            required: true,
            message: this.langList && this.langList.plcap ? this.langList.plcap : '请输入验证码',
            trigger: 'change'
          }
        ]
      }
    }
  },
  props: ['loginedFun'],
  mounted() {
    this.changePwdUrl = './forgetPassword'
    const agent = navigator.userAgent.toLowerCase()
    if (/macintosh|mac os x/i.test(agent)) {
      // mac
      this.google_url = 'https://dl.google.com/chrome/mac/stable/GGRO/googlechrome.dmg'
    } else if (/windows|win32/i.test(agent)) {
      // window
      this.google_url =
        'https://dl.google.com/tag/s/appguid%3D%7B8A69D345-D564-463C-AFF1-A69D9E530F96%7D%26iid%3D%7B4A29B013-5320-C2FC-11D5-03BFC29C34ED%7D%26lang%3Dzh-CN%26browser%3D4%26usagestats%3D0%26appname%3DGoogle%2520Chrome%26needsadmin%3Dprefers%26ap%3Dx64-stable-statsdef_1%26installdataindex%3Dempty/chrome/install/ChromeStandaloneSetup64.exe'
      // 搜狗
    }
    const showTipWebList = window.RENDER_DATA ? window.RENDER_DATA.showTipWebList || [] : [];

    this.isShowExtraLink = showTipWebList.some(item => window.origin.includes(item));
    getLangList().then(res => {
      this.langList = res.data || {}
      this.getPubCode()
      this.changeVerifyCode()
      setTimeout(() => {
        this.$refs['ruleForm'] && this.$refs['ruleForm'].resetFields()
      }, 0)
    })
  },
  methods: {
    async setLanuage(item) {
      const res = await setLanguage(item)
      if (res.code === 0) {
        const url = this.changeURLArg(window.location.href, 'lang', item.id)
        window.location.replace(url)
        // window.location.reload()
      }
    },
    login() {
      const info = `${this.form.user}\n${this.form.pwd}\n${this.form.verificationCode}`
      const encryptMsg = encryptInfo(this.publicCry, info)
      if (!encryptMsg) {
        this.$message.error(
          this.langList && this.langList.loginError
            ? this.langList.loginError
            : '登录出错，请刷新页面或联系开发人员'
        )
        return
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          checkLogin({ info: encryptMsg }).then((res) => {
            this.getPubCode()
            if (res.code !== 0) {
              this.changeVerifyCode()
              if (
                res.data === this.langList && this.langList.captchaError
                  ? this.langList.captchaError
                  : '验证码错误'
              ) {
                this.form.verificationCode = ''
              } else {
                this.form.verificationCode = ''
                this.form.pwd = ''
                this.form.user = ''
              }
            } else {
              this.$message.success(
                this.langList && this.langList.loginSuccess
                  ? this.langList.loginSuccess
                  : '登录成功！'
              )
              this.loginedFun && this.loginedFun()

              setToken().then((res2) => {
                if (res2.code !== 0) {
                  throw Error(res2.message)
                }
              })
              if (res.data && res.data.url) {
                console.log('res.data.url', res.data.url)
                window.location.href = res.data.url
              }
            }
          })
        } else {
          return false
        }
      })
    },
    async getPubCode() {
      getPubCode().then((res) => {
        this.publicCry = res ? res.data : ''
      })
    },
    changeVerifyCode() {
      changeVerifyCode().then((res) => {
        this.verifyImg = res.data
        const el = document.getElementById('verify-img-box')
        const dom = el ? el.children : null
        dom && dom.length && dom[0].setAttribute('class', 'verify-img')
      })
    },
    evil(fn) {
      const Fn = Function
      return new Fn('return ' + fn)()
    },
    changeURLArg(url, arg, arg_val) {
      var pattern = arg + '=([^&]*)'
      var replaceText = arg + '=' + arg_val
      if (url.match(pattern)) {
        var tmp = '/(' + arg + '=)([^&]*)/gi'
        tmp = url.replace(this.evil(tmp), replaceText)
        return tmp
      } else {
        if (url.match('[\?]')) {
          return url + '&' + replaceText
        } else {
          return url + '?' + replaceText
        }
      }
      // return url + '\n' + arg + '\n' + arg_val
    }
  }
}
</script>
<style lang="scss">
.login-box {
  img.password-close-icon {
    /* prettier-ignore */
    width: 20Px ;
    vertical-align: middle;
    height: auto !important;
    line-height: 100%;
    cursor: pointer;
    margin-top: 50%;
    transform: translateY(-20%);
  }
  li {
    list-style: none;
  }
  .login-txt {
    height: 100px;
    /* prettier-ignore */
    max-height: 100Px;
    line-height: 100px;
    margin-top: 25px;
    /* prettier-ignore */
    font-size: 40Px;
    color: #4281f7;
    .tab {
      float: left;
    }
  }
  .verify-box {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    line-height: 60px;
    #verify-img-box {
      flex: 1;
      cursor: pointer;
      display: inline-block;
      width: 70%;
      svg {
        width: 100% !important;
      }
    }
    .verify-img {
      position: relative;
      max-width: 150px;
      height: 110px;
      /* prettier-ignore */
      min-width: 85Px ;
      /* prettier-ignore */
      /* margin-right: 5Px; */
      top: -0.3rem;
      vertical-align: middle;
      font-size: 0;
    }
    .change-txt {
      display: inline-block;
      /*  width: 110px; */
      /* prettier-ignore */
      /*  max-width: 45Px; */
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-right: 2px; /*no*/
      /* prettier-ignore */
      font-size: 14Px;
      /* prettier-ignore */
      height: 100%;
      /* prettier-ignore */
      padding-left: 5Px;
      color: #4281f7;
      cursor: pointer;
      user-select: none;
    }
  }
  .login-btn,
  .login-btn:hover {
    background: #3665ec;
    color: #fff;
    width: 100%;
    border: 0 !important;
  }
  .jump-register {
    color: #4281f7;
    text-decoration: none;
    display: inline-block;
    /* prettier-ignore */
    margin-top: 6Px;
    margin-left: 3px;
  }
  .language-list {
    display: inline-block;
    float: right;
    .lng-txt {
      /* prettier-ignore */
      font-size: 14Px;
    }
  }
}
.languagePopper {
  /* prettier-ignore */
  padding: 12Px 0 !important;
}
.lang-item {
  list-style: none;
  /* prettier-ignore */
  padding: 0 12Px;
  /* prettier-ignore */
  line-height: 36Px;
  /* prettier-ignore */
  font-size: 14Px;
  cursor: pointer;
}
.lang-item:hover {
  background: #4d7ccd80;
}
.icon-language {
  width: 50px;
  /* prettier-ignore */
  max-width: 30Px;
  margin-right: 8px;
  vertical-align: middle;
}
.rechange-pwd {
  cursor: pointer;
  /* prettier-ignore */
  font-size: 12Px;
  /* prettier-ignore */
  margin-top: -8Px;
  display: flex;
  justify-content: space-between;
  a {
    color: #3665ec;
    text-decoration: none;
  }
}
.tip-link {
  line-height: 1.5;
  /* prettier-ignore */
  font-size: 12Px;
  /* prettier-ignore */
  margin-top: -8Px;
  display: flex;
  justify-content: space-between;
  a {
    color: #3665ec;
    text-decoration: none;
  }
}
.wrap-box {
  .el-input,
  .el-button,
  .el-form-item__error {
    /* prettier-ignore */
    font-size: 12Px;
  }
}
</style>
<style lang="scss" scoped>
.login-box {
  /deep/ .el-tabs--top .el-tabs__item {
    /* prettier-ignore */
    font-size: 14Px;
  }
  /deep/ .el-tabs__active-bar {
    bottom: 10px;
  }
  /deep/ .el-tabs__nav-wrap::after {
    bottom: 10px;
  }
}
</style>
